export default [
	{
		code: 'n',
		name: 'Employee',
	},
	{
		code: 'y',
		name: 'Agent',
	},
	{
		code: 'h',
		name: 'AthCap - Agent',
	},
	{
		code: 'e',
		name: 'AthCap - Employee',
	},
	{
		code: 'i',
		name: 'Intern',
	}
];